import React from 'react'

interface IconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    className?: string
}

const Icon = ({className, ...props}: IconProps) => {
    const baseClassName = `
        cursor-pointer
    `

    const buttonClasseName = `${baseClassName} ${className || ''}`

    return (
        <img
            className={buttonClasseName}
            alt={props.alt || 'icon'}
            {...props}
        />
    )
}

export default Icon
